import React, { ReactElement } from 'react';

type buttonProps = {
	type?: 'button' | 'submit' | 'reset';
	id?: string | number;
	title?: string;
	buttonRef?: React.Ref<HTMLButtonElement>;
	className?: string;
	disabled?: boolean;
	children?: ReactElement | JSX.Element | JSX.Element[] | string;
	onBlur?: (e: React.FocusEvent<HTMLButtonElement, Element>) => void;
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export function Button(props: buttonProps) {
	const { type = 'button' } = props;

	return (
		<button
			type={type}
			id={props.id?.toString()}
			title={props.title}
			ref={props.buttonRef}
			className={props.className}
			disabled={props.disabled}
			onBlur={(e) => props.onBlur?.(e)}
			onClick={(e) => props.onClick?.(e)}
		>
			{props.children}
		</button>
	);
}
